import Tooltip from '@mui/material/Tooltip';

const BalanceTransactionCards = ({
    combinedRows = [],
    activeTab,
    handleRowClick,
    viewEditAllocation,
    handleViewAllocation,
    selectedRow
}) => {
    const filteredRows = combinedRows.filter(row => {
        return activeTab === 'invoices' ? row.type === 'Invoice' : row.type === 'Payment';
    });

    return (
        <div className="card-table-container flex flex-col gap-[15px] md:hidden mt-[15px]">
            {filteredRows.length === 0 ? (
                <p className="info-text text-center">No data found</p>
            ) : (
                filteredRows.map((row) => (
                    <div
                        key={row.id}
                        onClick={() => handleRowClick(row)}
                        className={`border border-gray-300 rounded-lg p-6 w-full cursor-pointer ${selectedRow?.id === row.id ? 'bg-gray-100' : ''}`}
                    >
                        <div className="detail-column">
                            <p className="detail-label">Reference No.</p>
                            <p className="detail">{row.reference}</p>
                        </div>
                        <div className="detail-row -mt-[10px]">
                            <div className="detail-column mb-[-20px]">
                                <p className="detail-label">Date Created</p>
                                <p className="detail">{new Date(row.createdAt).toLocaleDateString()}</p>
                            </div>
                            <div className="detail-column mb-[-20px]">
                                <p className="detail-label">Amount</p>
                                <p className="detail">PHP {row.amount?.toLocaleString()}</p>
                            </div>
                        </div>

                        {row.isInvoice && (
                            <div className="detail-column mt-[15px]">
                                <p className="detail-label">Open Balance</p>
                                <p className="detail">
                                    PHP {row.openBalance?.toLocaleString()}{' '}
                                    <span style={{ color: row.openBalance === 0 ? 'green' : 'red' }}>
                                        ({row.openBalance === 0 ? 'Closed' : 'Open'})
                                    </span>
                                </p>
                            </div>
                        )}

                        {row.isInvoice && row.openBalance !== 0 && (
                            <div className="table-button-container flex gap-0" style={{ justifyContent: 'flex-end', marginTop: '-20px', marginBottom: '-10px' }}>
                                <button
                                    className="action-buttons"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        viewEditAllocation(row);
                                    }}
                                >
                                    <i className="fas fa-edit" style={{ fontSize: "22px" }}></i>
                                </button>

                                {row.reference === '-' ? (
                                    <Tooltip title="No payment allocation to view" placement="top" arrow disableInteractive>
                                        <span>
                                            <button className="action-buttons disabled">
                                                <i className="fas fa-eye" style={{ fontSize: "22px", marginRight: "-10px" }}></i>
                                            </button>
                                        </span>
                                    </Tooltip>
                                ) : (
                                    <button
                                        className="action-buttons"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleViewAllocation(row);
                                        }}
                                    >
                                        <i className="fas fa-eye" style={{ fontSize: "22px", marginRight: "-10px" }}></i>
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                ))
            )}
        </div>
    );
};

export default BalanceTransactionCards;
